import { render, staticRenderFns } from "./VendorDetailFormDialog.vue?vue&type=template&id=06581265&"
import script from "./VendorDetailFormDialog.vue?vue&type=script&lang=ts&"
export * from "./VendorDetailFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports